import videojs from 'video.js';

const Plugin = videojs.getPlugin('plugin');

/**
* Registers a Video.js plugin with the player to extend its functionality.
* @memberof MediasitePlayer#
* @param {string} name The name of the plugin to load. The plugin will be made available on this player instance as a property with the given key.
* @param {function} fn A function containing the plugin implementation.
* @example
* player.registerPlugin('myPlugin', function () { console.log('Called the plugin function.') });
* player.plugins.myPlugin();
*/
function registerPlugin(name, fn) {
    if (name && fn) {
        if (!videojs.getPlugin(name)) {
            videojs.registerPlugin(name, fn);
        }

        this.trigger('registercustomplugin', { name, isBasic: Plugin.isBasic(fn) });
        this.log(`Registered Video.js plugin: ${name}`);
    }
}

export default registerPlugin;
